// extracted by mini-css-extract-plugin
export default {"blankslateContainer":"blankslate-module__blankslateContainer--NI0uz","blankslateContent":"blankslate-module__blankslateContent--vaFyu"};